
const initialState = [];
export const terms = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_TERMS_DATA':
            return action.payload;
        case 'ADD_TERMS_DATA':
            return [...state, action.payload];
        case 'UPDATE_TERMS_DATA':
            const terms = state.slice();
            terms.splice(state.findIndex(x => x.idx === action.payload.idx), 1, action.payload);
            return [...terms];
        default:
            return state;
    }
};
